/* eslint-env node */
// Logika MURNI notifikasi di bell (Topbar.vue).
// Sengaja TANPA import Vue agar bisa diuji dengan Node biasa
// (lihat src/helpers/__tests__/notification.test.js).

// Peta tipe_notifikasi -> rute tujuan saat notifikasi diklik.
var NOTIF_ROUTES = {
  'pelaporan-kegiatan': '/info-ormas/domisili',
  'permohonan-perubahan': '/tata-kelola/permohonan',
  // Permohonan Akses Detail Ormas Badan Hukum (sior-badan-hukum)
  'akses-detail-bh': '/tata-kelola/permohonan', // ke approver
  'akses-detail-bh-hasil': '/info-ormas/domisili' // ke pemohon
};

function notifRoute(tipe) {
  return Object.prototype.hasOwnProperty.call(NOTIF_ROUTES, tipe) ? NOTIF_ROUTES[tipe] : null;
}

// Hanya notifikasi Akses Detail Badan Hukum yang menampilkan isi + waktu relatif.
function isAksesBh(tipe) {
  return tipe === 'akses-detail-bh' || tipe === 'akses-detail-bh-hasil';
}

var BULAN = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];

// "Baru saja" / "N menit yang lalu" / "N jam yang lalu", lewat 1 hari: "09 Oktober 2026".
function notifTime(createdAt, now) {
  var t = new Date(createdAt);
  if (!createdAt || isNaN(t.getTime())) return '';
  var menit = Math.floor(((now || new Date()) - t) / 60000);
  if (menit < 1) return 'Baru saja';
  if (menit < 60) return menit + ' menit yang lalu';
  if (menit < 24 * 60) return Math.floor(menit / 60) + ' jam yang lalu';
  return ('0' + t.getDate()).slice(-2) + ' ' + BULAN[t.getMonth()] + ' ' + t.getFullYear();
}

module.exports = {
  notifRoute: notifRoute,
  isAksesBh: isAksesBh,
  notifTime: notifTime
};
